import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-spinner',
  imports: [ProgressSpinner],
  template: ` <div
    class="absolute w-full h-full top-0 left-0 right-0 flex items-center justify-center bg-white/70 z-50"
  >
    <p-progressSpinner ariaLabel="loading" class="center-flex" />
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {}
